<!--待分配信息--->
<template>
    <div class="allocated-page">
        <div class="parent" v-if="!showList">
            <div class="parent-img-list">
                <img class="parent-img-detail" referrerpolicy="no-referrer" v-for="item in checkedEmployeesList.photolist" :key="item.id" :src="item.avatar" alt="" />
            </div>
            <div class="parent-text">
                <span v-if="checkedEmployeesList.photolist.length > 1">
                    {{ checkedEmployeesList.photolist[0].name }}等{{ checkedEmployeesList.photolist.length }}位离职成员的顾客与顾客群待分配</span>
                <span v-if="checkedEmployeesList.photolist.length == 1">{{ checkedEmployeesList.photolist[0].name }} 的顾客与顾客群待分配</span>
            </div>
            <div style="margin-top:20px;" class="parent-cell-list">
                <van-cell class="parent-cell" title="顾客" icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/inherit/customer.png" :value="'全部' + checkContactList.length + '位'" @click="getcustomer()" is-link />
            </div>
            <div class="parent-cell-list">
                <van-cell class="parent-cell" title="群顾客" icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/inherit/customerBase.png" :value="'全部' + checkedEmployeesList.groupCount + '个'" is-link />
            </div>

            <div class="parent-btn">
                <van-button class="parent-span" :disabled="checkContactList.length === 0" @click="toInheritEmployeesList()">分配给
                </van-button>
            </div>
        </div>
        <!-- 列表 -->
        <div class="child" v-if="showList">
            <div class="employess-list">
                <form action="/">
                    <van-search class="search-button" v-model="searchStr" placeholder="请输入搜索关键词" @search="onSearch" @clear="selClear" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                    </van-search>
                </form>
                <div class="child-list-box">
                    <van-checkbox class="child-allchecked" icon-size="18px" v-model="allChecked" @click="checkAll(allChecked)">全选
                    </van-checkbox>
                    <van-checkbox-group v-model="result" ref="checkboxGroup" @change="handleCheck">
                        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
                                <div class="child-list-div" v-for="(item, index) in checkedEmployeesList.contactList" @click="checkedDivHandle(item)" :key="index + item.id">
                                    <div class="child-contact-list flex-row">
                                        <van-checkbox class="child-check-box" icon-size="18px" :name="item" />
                                        <div class="child-img-div flex-col">
                                            <img class="child-img" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                                        </div>
                                        <div class="child-contact-txt-div flex-col justify-between">
                                            <span class="child-contact-txt">{{ item.name }}</span>
                                        </div>
                                        <!-- <img class="child-contact-label" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/inherit/node.png" /> -->
                                    </div>
                                    <div class="child-section flex-col"></div>
                                </div>
                            </van-list>
                        </van-pull-refresh>
                    </van-checkbox-group>
                </div>
                <div class="bot-div flex flex-between">
                    <div class="bot-list">
                        <img class="bot-list-img" referrerpolicy="no-referrer" v-for="(item, index) in checkContactList" :key="item.id + index" :src="item.avatar" alt="" />
                    </div>
                    <van-button round class="save_btn" @click="saveContact()">确定</van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import request from "@/utils/request";
    export default {
        name: "toAllocated",

        data() {
            return {
                // allocatedParams
                showList: false, // 是否显示子集
                checkedEmployeesList: {
                    contactCount: 0,
                    contactList: [], //总客户 
                    groupCount: 0,
                    photolist: []
                },
                checkContactList: [], //选中客户
                // childParams
                employeeIdsList: [],
                searchStr: "",
                page: 1,
                total: 0,
                loading: false,
                finished: false,
                refreshing: false,
                result: [],
                allChecked: false,
            };
        },
        mounted() {
            this.checkedEmployeesList = JSON.parse(this.$route.query.checkedEmployeesList);
            this.checkedEmployeesList.photolist.map(n => {
                this.employeeIdsList.push(n.id)
            })
        },
        methods: {
            // 清除
            selClear() {
                this.searchStr = ""
            },
            onLoad() {
                if (!this.showList)
                    return;

                if (this.refreshing) {
                    this.page = 1
                    this.refreshing = false;
                }
                this.loading = true
                request({
                    url: `/workEmployee/empContactList`,
                    method: "post",
                    data: { limit: "10", page: this.page + "", keyWords: this.searchStr, employeeIds: this.employeeIdsList },
                })
                    .then((res) => {
                        this.total = res.data.total
                        this.checkedEmployeesList.contactList = this.page == 1 ? res.data.list : this.checkedEmployeesList.contactList.concat(res.data.list);
                        this.page += 1;
                        this.total = res.data.total;
                        // 全选是否被勾选上
                        this.allCheckedHandle()

                    }).catch(() => {
                        this.finished = true
                    }).finally(() => {
                        this.loading = false;
                        if (this.checkedEmployeesList.contactList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            //搜索
            onSearch() {
                this.page = 1;
                this.checkContactList = [];
                this.onLoad();
            },
            //全选
            checkAll(checked) {
                if (checked)
                    this.$refs.checkboxGroup.toggleAll(true);
                else
                    this.$refs.checkboxGroup.toggleAll();
            },
            // 点击div选中
            checkedDivHandle(e) {
                // 获取过去已选择
                var val = this.checkContactList
                // 判断当前选中是否在过去已选择
                var sel = val.find(n => n.id === e.id)

                if (sel) // 如果在，去除
                    val = val.filter(n => n.id != e.id)
                else // 否则，添加
                    val.push(e)
                this.result = val
                // 模仿checkebox 选中
                this.handleCheck(val)
            },
            //check事件
            handleCheck(val) {
                this.checkContactList = []
                if (val.length) {
                    this.checkContactList = val
                } else {
                }
                this.allCheckedHandle(1)
            },
            // 全选按钮checked
            allCheckedHandle(val) {
                if (val == 1)
                    this.allChecked = this.checkContactList.length === this.checkedEmployeesList.contactList.length
                else

                    this.allChecked = false
            },
            // 清空list数据
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                this.loading = true;
                this.onLoad();
            },
            saveContact() {
                this.checkedEmployeesList.contactCount = this.checkContactList.length
                if (this.checkContactList.length == 0) {
                    this.$toast({
                        message: "请选择顾客",
                        position: 'top',
                    });
                }
                else {
                    this.showList = false
                }
            },
            //跳转选择客户页
            getcustomer() {
                this.showList = true;
                if (this.showList) this.onLoad();
            },
            //跳转员工页面
            toInheritEmployeesList() {
                var res = { photolist: [], checkContactList: [] }
                res.photolist = this.checkedEmployeesList.photolist
                res.checkContactList = this.checkContactList
                this.$router.push({ name: "inheritEmployeesList", query: { checkedEmployeesList: JSON.stringify(res) } });
            },
        },
    };
</script>


<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    .employess-list {
        background-color: #ffffff;
    }

    .child-list-box {
        height: 82vh;
        justify-content: space-between;
        margin: 0 auto 0;
        position: relative;
        z-index: 1;
        overflow-y: auto;
    }

    .child-allchecked {
        margin-top: 20px;
        margin-left: 30px;
    }

    .child-list-div {
        /* margin-top: 20px; */
        margin-left: 30px;
        padding-bottom: 1px;
    }

    .child-contact-list {
        background-color: rgb(255 255 255);
        /* height: 150px; */
    }

    .child-check-box {
        /* height: 35px; */
        margin-top: 30px;
        margin-left: 3px;
    }

    .child-img-div {
        position: relative;
        width: 70px;
        height: 70px;
        border-radius: 10px;
        overflow: hidden;
        margin-left: 30px;
        margin-top: 30px;
    }

    .child-img {
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;
        width: 70px;
        height: 70px;
    }

    .child-contact-txt-div {
        width: 90px;
        height: 92px;
        margin-left: 30px;
        margin-top: 52px;
    }

    .child-contact-txt {
        width: 90px;
        height: 42px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 30px;
        white-space: nowrap;
        line-height: 42px;
        text-align: left;
    }

    .child-contact-label {
        width: 32px;
        height: 32px;
        margin: 55px 0 0 384px;
    }

    .child-section {
        width: 506px;
        height: 1px;
        background-color: rgba(215, 215, 215, 1);
        margin: 2px 0 0 186px;
    }

    .bot-div {
        position: fixed;
        bottom: 0px;
        border: 1px solid rgba(203, 203, 203, 1);
        background-color: rgba(245, 246, 247, 1);
        width: 750px;
        z-index: 10;
        margin-top: 20px;
        /* height: 164px; */
    }

    .bot-list {
        width: 65%;
        height: 100px;
        display: flex;
        margin: 20px 10px 10px 10px;
        /* margin-top: 10px; */
        overflow-x: auto;
    }

    .bot-list-img {
        width: 70px;
        height: 70px;
        margin-left: 20px;
        border-radius: 5px;
    }

    .save_btn {
        width: 162px;
        height: 66px;
        background: #333f48;
        border-radius: 44px;
        font-size: 32px;
        color: rgba(255, 255, 255, 1);
        margin-top: 20px;
        margin-right: 15px;
    }

    .allocated-page {
        position: relative;
        width: 750px;
        height: 100%;
        /* background-color: rgba(245, 246, 247, 1); */
        overflow: hidden;
        overflow-y: auto;
    }

    .parent-img-list {
        width: 65%;
        height: 100px;
        display: flex;
        margin: 100px 10px 0px 10px;
        overflow-x: auto;
    }

    .parent-img-detail {
        border-radius: 10px;
        margin-left: 20px;
        white-space: nowrap;
        width: 60px;
        height: 60px;
    }

    .parent-text {
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 30px;
        white-space: nowrap;
        line-height: 42px;
        text-align: left;
        margin: 20px 0 0 30px;
    }

    .parent-cell-list {
        width: 100%;
        padding: 10px 30px 10px 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .parent-cell {
        /* background-color: rgba(255, 255, 255, 1); */
        width: 100%;
        border-radius: 8px;
    }

    :deep(.van-cell--clickable) {
        background: #ffffff !important;
    }

    .parent-btn {
        margin-top: 400px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .parent-span {
        background-color: #333f48;
        width: 80%;
        height: 80px;
        border-radius: 50px;
        color: rgba(255, 255, 255, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 32px;
    }

    .van-icon__image {
        margin-top: 2px;
        width: 40px;
        height: 40px;
    }

    :deep(.search-button.van-search) {
        padding: 30px 30px 30px 30px;
    }

    :deep(.search-button .van-icon) {
        font-size: 28px;
    }

    :deep(.search-button .van-search__content) {
        padding-left: 20px !important;
    }

    :deep(.search-button .van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 3px 20px 0 0 !important;
        margin-right: 0 !important;
    }

    :deep(.van-icon__image) {
        height: 28px;
        display: inline-block;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }
</style>